const Badge = ({ badgeName, onRemove }) => {
  return (
    <span className="inline-flex items-center gap-x-1 rounded-pill bg-accent-100 px-2.5 py-1 text-xs font-medium text-accent-700">
      <span className="size-1.5 rounded-full bg-accent-500" aria-hidden="true" />
      {badgeName}
      <button
        type="button"
        className="group relative -mr-1 ml-0.5 size-3.5 rounded-full hover:bg-accent-500/20"
        onClick={onRemove}
      >
        <span className="sr-only">Remove</span>
        <svg
          viewBox="0 0 14 14"
          className="size-3.5 stroke-accent-700/60 group-hover:stroke-accent-700"
        >
          <path d="M4 4l6 6m0-6l-6 6" />
        </svg>
        <span className="absolute -inset-1" />
      </button>
    </span>
  );
};

export default Badge;
